const icon = new URL('../../icons/signal-tower.png', import.meta.url).href

export default {
  type: 'signal-tower',
  description: 'Signal Tower',
  group: '3D' /* line|shape|textAndMedia|chartAndGauge|table|container|dataSource|IoT|3D|warehouse|form|etc */,
  icon,
  model: {
    type: 'signal-tower',
    left: 100,
    top: 100,
    width: 10,
    height: 120,
    depth: 100,
    fillStyle: '#333333',
    strokeStyle: '#999',
    lineWidth: 1,
    alpha: 1,
    value: 0,
    blink: false
  }
}
